import { render, staticRenderFns } from "./pgpro.vue?vue&type=template&id=4f49fff5&"
import script from "./pgpro.vue?vue&type=script&lang=js&"
export * from "./pgpro.vue?vue&type=script&lang=js&"
import style0 from "./pgpro.vue?vue&type=style&index=0&id=4f49fff5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports